(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-login/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/modules/iam-login/assets/javascripts/constants.js');

'use strict';

const isServer = svs.isServer;
const loginType = {
  BANKID: 'bankid',
  FREJAEID: 'frejaeid'
};
const loginMethods = {
  bankid: {
    icon: 'bankid-neg',
    pnpIcon: 'bankid-promo',
    buttonText: 'Starta',
    methodName: 'BankID',
    hasManualButton: true,
    isFreja: false,
    param: 'b',
    appUrl: 'https://www.bankid.com/privat/skaffa-bankid/'
  },
  freja: {
    icon: 'freja-eid-vertical-neg',
    pnpIcon: 'freja-eid-vertical',
    buttonText: 'Starta',
    methodName: 'Freja eID',
    hasManualButton: true,
    isFreja: true,
    param: 'f',
    appUrl: 'https://frejaeid.com/skaffa-freja-eid/'
  }
};
const constExports = {
  loginType,
  loginMethods
};
if (isServer) {
  module.exports = constExports;
} else {
  svs.iam_login.constants = constExports;
}

 })(window);